import { Components, Theme, Palette, PaletteColor } from '@mui/material';

export const MuiMenu = {
  styleOverrides: {
    list: ({ theme }) => ({
      padding: theme.spacing(0.5)
    })
  }
} as Components<Theme>['MuiMenu'];

export const MuiMenuItem = {
  defaultProps: {
    disableRipple: true,
    color: 'primary',
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const color = theme.palette[ownerState.color as keyof Palette] as PaletteColor;
      return {
        color: theme.palette.neutral.onSurface,
        ...theme.createStateLayer('transparent'),
        '&.Mui-selected': {
          backgroundColor: color.container,
          ...theme.createStateLayer('transparent'),
          '&:focus-within': {
            backgroundColor: color.container,
          },
        },
        '&.MuiTelInput-Typography-calling-code': {
          color: theme.palette.neutral.onSurface,
        }
      };
    }
  }
} as Components<Theme>['MuiMenuItem'];